import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _typeof from "@babel/runtime-corejs3/helpers/typeof";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context6, _context7; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context6 = ownKeys(Object(t), !0)).call(_context6, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context7 = ownKeys(Object(t))).call(_context7, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.regexp.exec.js";
import _everyInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/every";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
/* eslint-disable @typescript-eslint/no-explicit-any */
import translate from 'translate.js';
import { dayjs } from './dayjs';
import { SupportedLanguages } from './translator';
export var loaded = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, SupportedLanguages.de, []), SupportedLanguages.fr, []), SupportedLanguages.it, []), SupportedLanguages.en, []);
var isPluralizationObject = function isPluralizationObject(obj) {
  var _context;
  return _everyInstanceProperty(_context = _Object$keys(obj)).call(_context, function (key) {
    return /^\d+$/.test(key) || key === 'n';
  });
};
export var JsonFileTranslator = /*#__PURE__*/_createClass(function JsonFileTranslator() {
  var _this = this;
  _classCallCheck(this, JsonFileTranslator);
  _defineProperty(this, "language", SupportedLanguages.de);
  _defineProperty(this, "prefix", '');
  _defineProperty(this, "messages", {});
  _defineProperty(this, "translate", translate(this.messages));
  _defineProperty(this, "updateMessages", function (newMessages) {
    var _context2;
    _this.messages = _objectSpread(_objectSpread({}, _this.messages), _this.flattenMessages(newMessages, _concatInstanceProperty(_context2 = "".concat(_this.prefix, ".")).call(_context2, _this.language)));
    _this.translate = translate(_this.messages);
  });
  _defineProperty(this, "t", function (key, params, numerical) {
    var _context3, _context4;
    var keyWithPrefix = _concatInstanceProperty(_context3 = _concatInstanceProperty(_context4 = "".concat(_this.prefix, ".")).call(_context4, _this.language, ".")).call(_context3, key);
    if (numerical !== undefined && params !== undefined) {
      return _this.translate(keyWithPrefix, numerical, params);
    }
    if (numerical !== undefined) {
      return _this.translate(keyWithPrefix, numerical);
    }
    if (params !== undefined) {
      return _this.translate(keyWithPrefix, params);
    }
    return _this.translate(keyWithPrefix);
  });
  _defineProperty(this, "flattenMessages", function (messages, prefix) {
    var _context5;
    var pre = "".concat(prefix, ".");
    return _reduceInstanceProperty(_context5 = _Object$keys(messages)).call(_context5, function (acc, k) {
      if (_typeof(messages[k]) === 'object' && !isPluralizationObject(messages[k])) {
        _Object$assign(acc, _this.flattenMessages(messages[k], pre + k));
      } else {
        acc[pre + k] = messages[k];
      }
      return acc;
    }, {});
  });
});
export var jsonFileTranslator = new JsonFileTranslator();

/**
 * @deprecated Please use jsonFileTranslator
 */
export var i18n = jsonFileTranslator;
export var jsonFileTranslatorSetup = function jsonFileTranslatorSetup(language, prefix, translations) {
  jsonFileTranslator.prefix = prefix;
  jsonFileTranslator.language = language;
  jsonFileTranslator.updateMessages(translations);
  dayjs.locale(language);
  loaded[language].push(prefix);
};

/**
 * @deprecated Please use jsonFileTranslatorSetup
 */
export var i18nSetup = jsonFileTranslatorSetup;
export var getJsonFileTranslator = function getJsonFileTranslator(prefix) {
  return function () {
    jsonFileTranslator.prefix = prefix;
    return jsonFileTranslator;
  };
};

/**
 * @deprecated Please use getJsonFileTranslator
 */
export var getI18n = getJsonFileTranslator;

/**
 * @deprecated Please use jsonFileTranslator.language
 */
export var getCurrentLanguage = function getCurrentLanguage() {
  return jsonFileTranslator.language;
};